import { cn } from "@/lib/cn";
import { Icons } from "@/components/ui/icons";

/**
 * Workshop: Help section for Settings.
 * Static link list with documentation, changelog, shortcuts, and legal links.
 */

interface HelpLink {
  id: string;
  label: string;
  icon: React.ReactNode;
  testId: string;
}

const HELP_LINKS: HelpLink[] = [
  {
    id: "documentation",
    label: "Documentation",
    icon: <Icons.BookOpen className="h-4 w-4" />,
    testId: "help-link-documentation",
  },
  {
    id: "changelog",
    label: "Changelog",
    icon: <Icons.FileText className="h-4 w-4" />,
    testId: "help-link-changelog",
  },
  {
    id: "keyboard-shortcuts",
    label: "Keyboard Shortcuts",
    icon: <Icons.Keyboard className="h-4 w-4" />,
    testId: "help-link-keyboard-shortcuts",
  },
  {
    id: "privacy-policy",
    label: "Privacy Policy",
    icon: <Icons.Shield className="h-4 w-4" />,
    testId: "help-link-privacy-policy",
  },
  {
    id: "terms-of-service",
    label: "Terms of Service",
    icon: <Icons.FileText className="h-4 w-4" />,
    testId: "help-link-terms-of-service",
  },
];

interface HelpSectionProps {
  className?: string;
  "data-testid"?: string;
}

export function HelpSection({
  className,
  "data-testid": testId = "settings-help",
}: HelpSectionProps) {
  return (
    <div className={cn("flex flex-col gap-1", className)} data-testid={testId}>
      {HELP_LINKS.map((link) => (
        <a
          key={link.id}
          href="#"
          className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-secondary transition-colors hover:bg-btn-ghost-fill hover:text-primary"
          data-testid={link.testId}
        >
          {link.icon}
          <span className="flex-1 text-[11px]">{link.label}</span>
          <Icons.ExternalLink className="ml-auto h-3.5 w-3.5 text-muted" />
        </a>
      ))}

      {/* Version */}
      <p
        className="mt-4 px-3 text-[10px] text-secondary"
        data-testid="help-version"
      >
        Denker v0.1.0
      </p>
    </div>
  );
}

export type { HelpSectionProps };
